'use client';
import { useEffect, useState } from 'react';

import { utilScrollToElement } from '@/fo/util/scroll-to-element';

import { styles } from './UiLandingNavigationEsthederm.styles';

export interface Navigation {
  label: React.ReactNode;
  anchor: string;
}

export interface UiLandingNavigationEsthedermProps {
  className?: string;
  items: Navigation[];
}

export function UiLandingNavigationEsthederm({
  className,
  items
}: UiLandingNavigationEsthedermProps) {
  const slots = styles();
  const [activeAnchor, setActiveAnchor] = useState<string>('');

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const midY = windowHeight / 2;
      const headerHeight =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--head-fixed-height'
          )
        ) || 64;
      const topProbe = headerHeight + 1;

      let topAnchor = '';
      let midAnchor = '';
      let topHeight = 0;

      for (const item of items) {
        const element = document.getElementById(item.anchor);
        if (!element) continue;

        const rect = element.getBoundingClientRect();

        if (rect.top <= topProbe && rect.bottom > topProbe) {
          topAnchor = item.anchor;
          topHeight = rect.height;
        }

        if (rect.top <= midY && rect.bottom >= midY) {
          midAnchor = item.anchor;
        }
      }

      const active =
        topAnchor && topAnchor !== midAnchor && topHeight < windowHeight / 2
          ? topAnchor
          : midAnchor || topAnchor;

      if (active) setActiveAnchor(active);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [items]);

  const handleClick = (anchor: string) => {
    const element = document.getElementById(anchor);
    if (element) {
      utilScrollToElement(element);
    }
  };

  return (
    <div className={slots.base({ className })}>
      <ul className={slots.list()}>
        {items.map((item) => (
          <li
            className={slots.item()}
            key={item.anchor}
          >
            <button
              className={slots.button({
                isActive: activeAnchor === item.anchor
              })}
              onClick={() => handleClick(item.anchor)}
              type="button"
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
